/* Anatomia dello sticker — exploded real-image layers + numbered list.
   Modular: works on any [data-anat] block whose layers/rows carry data-layer. */
(function(){
  document.querySelectorAll('[data-anat]').forEach(function(root){
    var scene  = root.querySelector('[data-scene]');
    var items  = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    var rows   = Array.prototype.slice.call(root.querySelectorAll('.anat-row'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('.anat-layer'));
    var hits   = Array.prototype.slice.call(root.querySelectorAll('.anat-hit'));
    if(!scene || !rows.length) return;

    function setActive(i){
      scene.setAttribute('data-active', i);
      items.forEach(function(it){
        var row = it.querySelector('.anat-row');
        it.classList.toggle('is-active', +row.dataset.layer === i);
      });
      layers.forEach(function(l){
        l.classList.toggle('is-active', +l.dataset.layer === i);
      });
    }

    var canHover = window.matchMedia('(hover:hover)').matches;

    rows.forEach(function(r){
      var i = +r.dataset.layer;
      r.addEventListener('click', function(){ setActive(i); });
      if(canHover) r.addEventListener('mouseenter', function(){ setActive(i); });
    });
    hits.forEach(function(h){
      var i = +h.dataset.layer;
      h.addEventListener('click', function(){ setActive(i); });
      if(canHover) h.addEventListener('mouseenter', function(){ setActive(i); });
    });

    setActive(1);

    // Explode when the section scrolls into view
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(en){
          if(en.isIntersecting){ scene.classList.add('is-exploded'); io.disconnect(); }
        });
      }, { threshold:0.25 });
      io.observe(scene);
    } else {
      scene.classList.add('is-exploded');
    }
  });
})();
